import { once } from 'lodash-es';

const cdnUrlKey = 'rdcCdnUrl';
export const assetCdnUrlFactory = once(() => {
    let cdnUrl: string | null = null;
    const stored = sessionStorage?.getItem(cdnUrlKey);

    try {
        if (stored) {
            cdnUrl = JSON.parse(stored) as string;
        }
    } catch {
        cdnUrl = stored;
    }

    if (cdnUrl) {
        return cdnUrl.endsWith('/') ? cdnUrl : `${cdnUrl}/`;
    }
    return '/';
});
